exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-create-continue {\r\n  text-transform: uppercase;\r\n  background-color: #f8f8f8;\r\n  border: solid 1px #929190;\r\n}\r\n\r\n.btn-create-continue:hover {\r\n  cursor: pointer;\r\n  background-color: #e3e3e3;\r\n}\r\n\r\nli {\r\n  list-style-type: none;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-three/opst-step-three.component.css
// module id = ../../../../../src/app/content-page/admin/create-operating-standard/opst-step-three/opst-step-three.component.css
// module chunks = main